//extend simple implementation

module.exports = function (a, b, c, d, e, f) {
  var objs = [b, c, d, e, f].filter(Boolean);
  var target = a || {};
  objs.forEach(function (source) {
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        target[key] = source[key];
      }
    }
  });
  return target;
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/common/mixin.js
// module id = 41
// module chunks = 0